import type { AppRouteRecord } from '../types';
import { ROUTE_NAMES, ROUTE_PATHS } from '../constants';

export const hoursRoutes: AppRouteRecord[] = [
  {
    path: ROUTE_PATHS.HOURS,
    name: ROUTE_NAMES.HOURS,
    component: () => import('@/pages/HoursPage.vue'),
  },
];
